<template>
  <a-drawer
    :title="$t('服务订单.订单详情')"
    :width="720"
    :visible="open"
    @cancel="cancel"
    @close="cancel"
  >
    <a-descriptions :column="2" bordered size="middle">
      <!-- 基本信息 -->
      <a-descriptions-item :label="$t('服务订单.订单编号')" :span="2">
        {{ detail.orderNo }}
      </a-descriptions-item>
      <a-descriptions-item :label="$t('服务订单.订单类型')">
        <a-tag :color="detail.orderType === 1 ? 'blue' : 'purple'">
          {{ detail.orderTypeName || '-' }}
        </a-tag>
      </a-descriptions-item>
      <a-descriptions-item :label="$t('服务订单.服务类型')">
        {{ detail.serviceTypeName || '-' }}
      </a-descriptions-item>
      <a-descriptions-item :label="$t('服务订单.订单状态')">
        <a-tag :color="getStatusColor(detail.orderStatus)">
          {{ detail.orderStatusName || '-' }}
        </a-tag>
      </a-descriptions-item>
      <a-descriptions-item :label="$t('服务订单.创建时间')">
        {{ detail.createTime ? parseTime(detail.createTime) : '-' }}
      </a-descriptions-item>
    </a-descriptions>

    <a-divider orientation="left">{{ $t('服务订单.服务信息') }}</a-divider>
    <a-descriptions :column="2" bordered size="middle">
      <a-descriptions-item :label="$t('服务订单.服务名称')" :span="2">
        <div style="display:flex;align-items:center;">
          <img v-if="detail.servicePicture" :src="detail.servicePicture" style="width:60px;height:60px;margin-right:10px;cursor:pointer;" @click="handlePreview(detail.servicePicture)" />
          {{ detail.serviceName || '-' }}
        </div>
      </a-descriptions-item>
      <a-descriptions-item :label="$t('服务订单.服务项目名称')">
        {{ detail.serviceItemName || '-' }}
      </a-descriptions-item>
      <a-descriptions-item :label="$t('服务订单.预约服务时间')">
        {{ detail.serviceTimeRange || '-' }}
      </a-descriptions-item>
      <a-descriptions-item :label="$t('服务订单.服务地址')" :span="2">
        {{ detail.addressDetail || '-' }}
      </a-descriptions-item>
      <a-descriptions-item :label="$t('服务订单.联系人姓名')">
        {{ detail.contactName || '-' }}
      </a-descriptions-item>
      <a-descriptions-item :label="$t('服务订单.联系人电话')">
        {{ detail.contactPhone || '-' }}
      </a-descriptions-item>
      <a-descriptions-item :label="$t('服务订单.用户备注')" :span="2" v-if="detail.userRemark">
        {{ detail.userRemark }}
      </a-descriptions-item>
      <a-descriptions-item :label="$t('服务订单.用户备注图片')" :span="2" v-if="remarkImages.length > 0">
        <img
          v-for="(img, index) in remarkImages"
          :key="index"
          :src="img"
          style="width:60px;height:60px;margin-right:8px;cursor:pointer;"
          @click="handlePreview(img)"
        />
      </a-descriptions-item>
    </a-descriptions>

    <a-divider orientation="left">{{ $t('服务订单.用户信息') }}</a-divider>
    <a-descriptions :column="2" bordered size="middle">
      <a-descriptions-item :label="$t('服务订单.用户昵称')">
        {{ detail.userNickName || '-' }}
      </a-descriptions-item>
      <a-descriptions-item :label="$t('服务订单.用户手机号')">
        {{ detail.userMobile || '-' }}
      </a-descriptions-item>
    </a-descriptions>

    <a-divider orientation="left">{{ $t('服务订单.接单方信息') }}</a-divider>
    <a-descriptions :column="2" bordered size="middle">
      <a-descriptions-item :label="$t('服务订单.接单方名称')">
        {{ acceptor.name || '-' }}
      </a-descriptions-item>
      <a-descriptions-item :label="$t('服务订单.接单方头像')">
        <img v-if="acceptor.avatar" :src="acceptor.avatar" style="width:60px;height:60px;" />
        <span v-else>-</span>
      </a-descriptions-item>
      <a-descriptions-item :label="$t('服务订单.接单方电话')">
        {{ acceptor.phone || '-' }}
      </a-descriptions-item>
      <a-descriptions-item :label="$t('服务订单.接单方星级')">
        <a-rate v-if="acceptor.rating" :value="acceptor.rating" disabled allow-half />
        <span v-else>-</span>
      </a-descriptions-item>
    </a-descriptions>

    <!-- 加价信息 -->
    <template v-if="addPriceRecords.length > 0">
      <a-divider orientation="left">{{ $t('服务订单.加价信息') }}</a-divider>
      <div v-for="(record, recordIndex) in addPriceRecords" :key="record.id || recordIndex" style="margin-bottom:16px;">
        <div style="margin-bottom:8px;color:#888;">第{{ addPriceRecords.length - recordIndex }}条 · {{ record.createTime ? parseTime(record.createTime) : '-' }}</div>
        <a-descriptions :column="2" bordered size="middle">
          <a-descriptions-item :label="$t('服务订单.加价状态')">
            <a-tag :color="getAddPriceStatusColor(record.status)">
              {{ record.statusName || '-' }}
            </a-tag>
          </a-descriptions-item>
          <a-descriptions-item :label="$t('服务订单.加价金额')">
            <span style="color:#f5222d;font-weight:500;">¥{{ record.addPriceAmount || 0 }}</span>
          </a-descriptions-item>
          <a-descriptions-item :label="$t('服务订单.加价备注')" :span="2" v-if="record.addPriceRemark">
            {{ record.addPriceRemark }}
          </a-descriptions-item>
          <a-descriptions-item :label="$t('服务订单.加价图片')" :span="2" v-if="toArray(record.addPriceImageList || record.addPriceImages).length > 0">
            <img
              v-for="(img, index) in toArray(record.addPriceImageList || record.addPriceImages)"
              :key="index"
              :src="img"
              style="width:60px;height:60px;margin-right:8px;cursor:pointer;"
              @click="handlePreview(img)"
            />
          </a-descriptions-item>
        </a-descriptions>
      </div>
    </template>

    <!-- 完成信息 -->
    <template v-if="detail.orderStatus === 4">
      <a-divider orientation="left">{{ $t('服务订单.完成信息') }}</a-divider>
      <a-descriptions :column="2" bordered size="middle">
        <a-descriptions-item :label="$t('服务订单.完成时间')">
          {{ detail.serviceCompleteTime ? parseTime(detail.serviceCompleteTime) : '-' }}
        </a-descriptions-item>
        <a-descriptions-item :label="$t('服务订单.服务完成备注')" :span="2" v-if="detail.serviceRemark">
          {{ detail.serviceRemark }}
        </a-descriptions-item>
        <a-descriptions-item :label="$t('服务订单.服务完成图片')" :span="2" v-if="finishImages.length > 0">
          <img
            v-for="(img, index) in finishImages"
            :key="index"
            :src="img"
            style="width:60px;height:60px;margin-right:8px;cursor:pointer;"
            @click="handlePreview(img)"
          />
        </a-descriptions-item>
      </a-descriptions>
    </template>

    <!-- 评价信息 -->
    <template v-if="detail.rating">
      <a-divider orientation="left">{{ $t('服务订单.评价信息') }}</a-divider>
      <a-descriptions :column="2" bordered size="middle">
        <a-descriptions-item :label="$t('服务订单.评价星级')">
          <a-rate :value="detail.rating" disabled allow-half />
        </a-descriptions-item>
        <a-descriptions-item :label="$t('服务订单.评价时间')">
          {{ detail.commentTime ? parseTime(detail.commentTime) : '-' }}
        </a-descriptions-item>
        <a-descriptions-item :label="$t('服务订单.评价内容')" :span="2" v-if="detail.comment">
          {{ detail.comment }}
        </a-descriptions-item>
      </a-descriptions>
    </template>

    <!-- 取消信息 -->
    <template v-if="detail.orderStatus === 5">
      <a-divider orientation="left">{{ $t('服务订单.取消信息') }}</a-divider>
      <a-descriptions :column="2" bordered size="middle">
        <a-descriptions-item :label="$t('服务订单.取消方')">
          {{ detail.cancelTypeName || '-' }}
        </a-descriptions-item>
        <a-descriptions-item :label="$t('服务订单.取消时间')">
          {{ detail.cancelTime ? parseTime(detail.cancelTime) : '-' }}
        </a-descriptions-item>
        <a-descriptions-item :label="$t('服务订单.取消原因')" :span="2" v-if="detail.cancelReason">
          {{ detail.cancelReason }}
        </a-descriptions-item>
      </a-descriptions>
    </template>

    <!-- 金额信息 -->
    <a-divider orientation="left">{{ $t('服务订单.金额信息') }}</a-divider>
    <a-descriptions :column="2" bordered size="middle">
      <a-descriptions-item :label="$t('服务订单.订单原价')">
        <span>¥{{ detail.orderAmount || 0 }}</span>
      </a-descriptions-item>
      <a-descriptions-item :label="$t('服务订单.优惠金额')">
        <span>¥{{ detail.couponAmount || 0 }}</span>
      </a-descriptions-item>
      <a-descriptions-item :label="$t('服务订单.实付金额')">
        <span style="color:#f5222d;font-weight:500;font-size:16px;">¥{{ detail.payAmount || 0 }}</span>
      </a-descriptions-item>
      <a-descriptions-item :label="$t('服务订单.支付方式')">
        {{ detail.payTypeName || '-' }}
      </a-descriptions-item>
      <a-descriptions-item :label="$t('服务订单.支付时间')" v-if="detail.payTime">
        {{ parseTime(detail.payTime) }}
      </a-descriptions-item>
    </a-descriptions>

    <!-- 图片预览 -->
    <a-modal :visible="previewVisible" :footer="null" @cancel="previewCancel">
      <img alt="preview" style="width: 100%" :src="previewUrl" />
    </a-modal>
  </a-drawer>
</template>

<script>
import { getHomeServiceOrder } from '@/api/homeservice/order'

export default {
  name: 'DetailForm',
  data() {
    return {
      open: false,
      detail: {},
      previewVisible: false,
      previewUrl: ''
    }
  },
  computed: {
    // 接单方信息（师傅 > 个体户 > 社区）
    acceptor() {
      const d = this.detail
      if (d.workerId) {
        return { name: d.workerName, avatar: d.workerAvatar, phone: d.workerPhone, rating: d.workerRating }
      }
      if (d.individualId) {
        return { name: d.individualName, avatar: d.individualAvatar, phone: d.individualPhone, rating: d.individualRating }
      }
      return { name: d.communityName, avatar: null, phone: null, rating: null }
    },
    remarkImages() {
      return this.toArray(this.detail.userRemarkImages)
    },
    finishImages() {
      return this.toArray(this.detail.serviceImages)
    },
    addPriceRecords() {
      if (Array.isArray(this.detail.addPriceRecords)) return this.detail.addPriceRecords
      if (!this.detail.hasAddPrice) return []
      return [{
        status: this.detail.addPriceStatus,
        statusName: this.detail.addPriceStatusName,
        addPriceAmount: this.detail.addPriceAmount,
        addPriceRemark: this.detail.addPriceRemark,
        addPriceImages: this.detail.addPriceImages
      }]
    }
  },
  methods: {
    handleDetail(record) {
      this.detail = {}
      getHomeServiceOrder({ id: record.id }).then(response => {
        this.detail = response.data || {}
        this.open = true
      })
    },
    // 兼容后端返回字符串（逗号分隔）或数组两种情况
    toArray(value) {
      if (!value) return []
      if (Array.isArray(value)) return value.filter(item => item)
      return String(value).split(',').filter(item => item)
    },
    cancel() {
      this.open = false
      this.detail = {}
    },
    handlePreview(url) {
      this.previewUrl = url
      this.previewVisible = true
    },
    previewCancel() {
      this.previewVisible = false
    },
    getStatusColor(status) {
      const colorMap = {
        0: 'orange',     // 待支付
        1: 'blue',       // 待接单
        2: 'cyan',       // 待服务
        3: 'processing', // 服务中
        4: 'green',      // 已完成
        5: 'red'         // 已取消
      }
      return colorMap[status] || 'default'
    },
    getAddPriceStatusColor(status) {
      const colorMap = {
        0: 'gold',      // 待确认
        1: 'blue',      // 已确认待支付
        2: 'green',     // 已支付
        3: 'red'        // 已拒绝
      }
      return colorMap[status] || 'default'
    },
    parseTime(time, format) {
      if (!time) return '-'
      const date = typeof time === 'string' ? new Date(time.replace(/-/g, '/')) : time
      if (format) {
        const year = date.getFullYear()
        const month = (date.getMonth() + 1).toString().padStart(2, '0')
        const day = date.getDate().toString().padStart(2, '0')
        const hours = date.getHours().toString().padStart(2, '0')
        const minutes = date.getMinutes().toString().padStart(2, '0')
        const seconds = date.getSeconds().toString().padStart(2, '0')
        return format.replace('{y}', year).replace('{m}', month).replace('{d}', day)
          .replace('{h}', hours).replace('{i}', minutes).replace('{s}', seconds)
      }
      return date.toLocaleString('zh-CN', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' })
    }
  }
}
</script>

<style scoped>
/* 修复Drawer底部的按钮区域 */
::deep(.ant-drawer-footer) {
  display: none;
}
</style>
